import Page from 'components/pages/post-id'
import postRequest from 'request/common/post'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  const postId = parseInt(params.id)
  if (!postId) return { notFound: true }
  const post = await postRequest(postId)
  if (!post || !post.stylist) return { notFound: true }
  const fetchBreadcrumbs = async() => {
    const findStylist = {
      name: i18n.t('common:breadcrumb.stylist'),
      href: h.path.stylists()
    }
    const stylistName = { name: post.user.name }
    if (!post.stylist.studio) return [findStylist, stylistName]
    const city = await store.findCity(post.stylist.studio.city)
    if (!city) return { notFound: true }
    const district = await store.findDistrict(city.name, post.stylist.studio.district)
    if (!district) return { notFound: true }

    return [
      findStylist,
      {
        name: city.name,
        href: h.path.stylists({ city: city.key })
      },
      {
        name: district.name,
        href: h.path.stylists({ city: city.key, district: district.key })
      },
      stylistName
    ]
  }
  const breadcrumbs = await fetchBreadcrumbs()
  if (breadcrumbs.notFound) return { notFound: true }
  return { props: { post, breadcrumbs }, revalidate: 60 * 30 }
}

export default function PostId(initData) {
  const t = useI18n()
  const { post } = initData
  const description = post.description.noNewLine()
  const title = t.seo.title('custom', { value: post.user.name })
  const ogImage = fetchOgImage(post)
  const url = h.path.full.post({ id: post.id })
  return (
    <>
      <C.Head>
        { h.seo({ title, description })}
        { h.og({ image: ogImage }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'CreativeWork',
          'author': {
            '@type': 'Person',
            'name': post.user.name
          },
          'publisher': {
            '@type': 'Organization',
            'name': 'StyleMap',
            'logo': {
              '@type': 'ImageObject',
              'url': cdn('logo_sign.png'),
              'width': 250,
              'height': 60
            }
          },
          'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': url
          },
          'image': {
            '@type': 'ImageObject',
            'url': ogImage.url,
            'width': ogImage.width,
            'height': ogImage.height
          },
          'datePublished': post.createdAt,
          'headline': title,
          'description': description
        }) }
      </C.Head>
      <Page { ...initData } />
    </>
  )
}

const fetchOgImage = post => {
  const { postMetaImage, photos } = post
  if (postMetaImage) return {
    url: postMetaImage.url,
    width: postMetaImage.width,
    height: postMetaImage.height
  }

  const photo = photos[0]
  return {
    url: h.path.postPhoto({ id: photo.id, size: 'normal' }),
    width: photo.width,
    height: photo.height
  }
}
